import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import swal from 'sweetalert2';

import { cityList, menuEdit, zoneList } from '../../../store/actions';

class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editModal: false,
      editShowLoader: true,
      editShowBody: false,
      name: this.props.name,
      cityId: this.props.cityId,
      zoneId: this.props.zoneId,
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      editShowLoader: false,
      editShowBody: true,
    });
    // list cities
    this.props.cityList();
    // list zones
    const zoneListParams = {
      city_id: this.props.cityId,
      is_active: 1,
      type: 'all',
    };
    this.props.zoneList(zoneListParams);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.editedMenu.menu) {
      this.props.onMenuEdited();
      this.props.closeModal();
      this.setState({
        editShowLoader: false,
        editShowBody: true,
      });
      this.toggle();
      swal.fire({
        title: 'Success',
        type: 'success',
        text: 'Menu updated successfully!',
        timer: 3000,
      });
    }
  }

  toggle() {
    this.setState({
      editModal: !this.state.editModal,
    });
  }

  handleChange(event) {
    const inputName = event.target.name;
    const inputValue = event.target.value;
    this.setState({ [inputName]: inputValue });
  }

  handleCityChange(event) {
    const cityId = event.target.value;
    this.setState({
      cityId: cityId,
    });
    const zoneListParams = {
      city_id: cityId,
      is_active: 1,
      type: 'all',
    };
    this.props.zoneList(zoneListParams);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      editShowLoader: true,
      editShowBody: false,
    });

    const data = {
      name: this.state.name,
      zone_id: this.state.zoneId,
    };

    this.props.menuEdit(this.props.menuId, data);
  }

  render() {
    return (
      <div>
        <Button
          color={'success'}
          onClick={this.toggle}
          title={'edit-menu'}
          className={
            'm-portlet__nav-link btn btn-lg btn-secondary  m-btn m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle'
          }>
          <i className={'la la-edit m--font-brand'} />
        </Button>
        <Modal size={'sm'} isOpen={this.state.editModal}>
          <form onSubmit={this.handleSubmit}>
            <ModalHeader>{'Edit Menu'}</ModalHeader>
            <ModalBody>
              <div
                style={this.state.editShowLoader ? {} : { display: 'none' }}
                className={'loader'}
              />
              <div
                style={this.state.editShowBody ? {} : { display: 'none' }}
                className={'modal-body-content'}>
                <div className={'form-group m-form__group'}>
                  <label>{'Name'}</label>
                  <input
                    className={'form-control m-input m-input--air m-input--pill'}
                    type={'text'}
                    name={'name'}
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                </div>

                <div>
                  <label>{'Cities'}</label>
                  <select
                    className={'form-control m-input m-input--air m-input--pill'}
                    name={'city_id'}
                    value={this.state.cityId}
                    onChange={this.handleCityChange}
                    disabled>
                    <option key={'all'} value={''}>
                      {'Cities'}
                    </option>
                    {this.props.cities.map((city) => {
                      if (city.active) {
                        return (
                          <option key={city.id} value={city.id}>
                            {city.en_name}
                          </option>
                        );
                      }
                    })}
                  </select>
                </div>

                <div className={'form-group m-form__group'}>
                  <label>{'Zones'}</label>
                  <select
                    className={'form-control m-input m-input--air m-input--pill'}
                    name={'zoneId'}
                    value={this.state.zoneId}
                    onChange={this.handleChange}>
                    <option key={'all'} value={0}>
                      {'Choose Zone'}
                    </option>
                    {this.props.zones.map(function(zone, index) {
                      return (
                        <option key={index} value={zone.id}>
                          {zone.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </ModalBody>
            <ModalFooter style={this.state.editShowBody ? {} : { display: 'none' }}>
              <input
                type={'submit'}
                value={'Submit'}
                color={'primary'}
                className={'btn btn-primary'}
              />
              <Button color={'danger'} onClick={this.toggle}>
                {'Cancel'}
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cities: state.cityList.data,
    zones: state.zoneList.data,
    editedMenu: state.menuEdit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cityList() {
      dispatch(cityList());
    },
    zoneList(params) {
      dispatch(zoneList(params));
    },
    menuEdit(menuId, data) {
      dispatch(menuEdit(menuId, data));
    },
    closeModal() {
      dispatch({ type: 'CLOSE_MODAL' });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditModal);
